import { render } from "./InvoiceList.vue?vue&type=template&id=f32bc648&scoped=true"
import script from "./InvoiceList.vue?vue&type=script&lang=js"
export * from "./InvoiceList.vue?vue&type=script&lang=js"

import "./InvoiceList.vue?vue&type=style&index=0&id=f32bc648&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f32bc648"]])

export default __exports__